import {
  CHANGE_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  PROFILE_ROUTE,
  USER_NOTIFICATION_ROUTE,
} from 'config/route-consts';
import { DEFAULT_TAKE, GlobalState } from 'core/config';
import { debounce } from 'core/helpers/debounce';
import { buildAbsoluteLink } from 'core/helpers/string';
import { notification } from 'helpers';
import { AppUser } from 'models/AppUser';
import { AppUserSiteMapping } from 'models/AppUserSiteMapping';
import { UserNotification } from 'models/UserNotication';
import { UserNoticationFilter } from 'models/UserNoticationFilter';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { LogIn, Mail, User } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { setGlobal } from 'reactn';
import { DropdownMenu } from 'reactstrap';
import authenticationService from 'services/AuthenticationService';
import { SignalRService } from 'services/SignalRService';
import './DefaultHeader.scss';
import userNotificationRepository from './UserNotificationRepository';
import i18next from 'i18next';
import AuthenticationService from 'services/AuthenticationService';
import axios, { AxiosResponse } from 'axios';
import path from 'path';
export default function useDefaultHeader(user: AppUser, service, channel) {
  const [translate] = useTranslation();

  const [visibleApp, setVisibleApp] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);

  const [total, setTotal] = useState<number>(0);

  const [visibleNotification, setVisibleNotification] = useState<boolean>(
    false,
  );

  const [visibleMenuAction, setVisibleMenuAction] = useState<boolean>(false);

  const [notifications, setNotifications] = useState<UserNotification[]>([]);

  const [notificationFilter, setNotificationFilter] = useState<
    UserNoticationFilter
  >(new UserNoticationFilter());

  const [fetchNotification, setFetchNotification] = useState<boolean>(false);

  const [loadingNotification, setLoadingNotification] = useState<boolean>(
    false,
  );

  const [unreadNotification, dispatchNotification] = useReducer(
    newNotificationReducer,
    0,
  );

  const [subcribe, setSubcribe] = useState<boolean>(true);

  const PortalPermission = useMemo(() => {
    if (!user || !user.appUserSiteMappings) {
      return false;
    }
    return user.appUserSiteMappings.some(
      mapping => mapping.siteId === 1 && mapping.enabled,
    );
  }, [user]);

  const fetchUnreadNotification = useCallback(async () => {
    try {
      const total = await userNotificationRepository.countUnread(
        notificationFilter,
      );
      await dispatchNotification({ type: COUNT_UNREAD, payload: { total } });
    } catch (ex) {
      // tslint:disable-next-line:no-console
      console.log(`ex:`, ex);
    }
  }, [notificationFilter]);

  /* subcribe channel */
  const subcribeChannel = useCallback(
    (signalRService: SignalRService, channel: string) => {
      return signalRService.registerChannel(
        channel,
        (data: UserNotification) => {
          // tslint:disable-next-line:no-console
          console.log(`data`, data);
          // dispatch count unread
          fetchUnreadNotification();
          // fire toast to notice new notification
          notification.open(notificationConfig(data));
        },
      );
    },
    [fetchUnreadNotification],
  );

  useEffect(() => {
    fetchUnreadNotification();
  }, [fetchUnreadNotification]);

  /* refactor subcribe channel */
  useEffect(() => {
    if (subcribe) {
      subcribeChannel(service, channel);
      setSubcribe(false);
    }
  }, [channel, service, subcribe, subcribeChannel]);

  const [hasMore, setHasMore] = useState<boolean>(true);
  useEffect(() => {
    const cancelled = false;
    if (fetchNotification) {
      const fetchData = async () => {
        await setLoadingNotification(true);
        const data = await userNotificationRepository.list(notificationFilter);
        const count = await userNotificationRepository.count(
          notificationFilter,
        );
        if (!cancelled) {
          await setNotifications([...data]);
          await setTotal(count);
        }
        await setFetchNotification(false);
        await setLoadingNotification(false);
      };
      fetchData();
    }
  }, [fetchNotification, notificationFilter]);

  /* handleToggerNotification */
  const handleToggleNotification = useCallback(() => {
    /* if notification is closing, set fetch data = true */
    if (!visibleNotification) {
      setNotificationFilter({
        ...notificationFilter,
        skip: 0,
        take: DEFAULT_TAKE,
      });
      setHasMore(true);
      setFetchNotification(true);
    }
    setNotifications([]);
    setVisibleNotification(!visibleNotification);
  }, [notificationFilter, visibleNotification]);

  const handleToggleMenuAction = useCallback(() => {
    /* if notification is closing, set fetch data = true */

    setVisibleMenuAction(!visibleMenuAction);
  }, [setVisibleMenuAction, visibleMenuAction]);

  /* handleInfiniteOnLoad */
  const handleInfiniteOnLoad = useCallback(
    debounce(() => {
      if (notificationFilter.skip + 10 >= total) {
        setLoadingNotification(false);
        setHasMore(false);
        return;
      }
      /* fetch notification with effect */
      const fetch = async () => {
        await setLoadingNotification(true);
        const data = await userNotificationRepository.list({
          ...notificationFilter,
          skip: notificationFilter.skip + 10,
        });
        await setNotifications([...notifications, ...data]);
        await setNotificationFilter({
          ...notificationFilter,
          skip: notificationFilter.skip + 10,
        });
        await setLoadingNotification(false);
      };
      fetch();
    }),
    [total, notificationFilter, notifications],
  );

  const codeLanding = '/landing/';

  const handleClick = React.useCallback(
    (project: string) => {
      return () => {
        // ev.preventDefault();
        if (
          user &&
          user.appUserSiteMappings &&
          user.appUserSiteMappings.length > 0
        ) {
          user.appUserSiteMappings.map((item: AppUserSiteMapping) => {
            if (item.site.code === project) {
              window.location.href = `${item.site.code}`;
            }
            return window.location.href;
          });
          return;
        }
      };
    },
    [user],
  );

  const handleShowApp = React.useCallback(() => {
    setVisibleApp(!visibleApp);
  }, [visibleApp]);

  const handleClickToProfile = React.useCallback(() => {
    window.location.href = PROFILE_ROUTE;
  }, []);

  const handleClickToChangePassword = React.useCallback(() => {
    window.location.href = CHANGE_PASSWORD_ROUTE;
  }, []);

  const handleClickToNotification = React.useCallback(() => {
    window.location.href = USER_NOTIFICATION_ROUTE;
  }, []);

  const handleLogout = React.useCallback(() => {
    setLoading(true);
    authenticationService
      .logout()
      .then(() => {
        setLoading(false);
        setGlobal<GlobalState>({
          user: null,
        });
        localStorage.removeItem('profile');
        localStorage.removeItem('redirectLink');
        localStorage.removeItem('dataConfiguration');
        window.location.href = LOGIN_ROUTE;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const menuLandingPage = (
    <DropdownMenu className="menu-dropdown">
      <div className="profile-dropdown">
        <li onClick={handleClickToProfile}>
          <User />
          <span>{user?.displayName} </span>
        </li>
        {!user?.isSSO && (
          <li onClick={handleClickToChangePassword}>
            <Mail />
            <span> {translate('general.defaultHeader.changePass')}</span>
          </li>
        )}
        <li onClick={handleLogout}>
          <LogIn />
          <span>{translate('general.defaultHeader.logout')}</span>
        </li>
      </div>
    </DropdownMenu>
  );

  const menu = (
    <div className="profile-dropdown">
      <li onClick={handleClickToProfile}>
        <User />
        <span>{user?.displayName} </span>
      </li>
      {!user?.isSSO && (
        <li onClick={handleClickToChangePassword}>
          <Mail />
          <span> {translate('general.defaultHeader.changePass')}</span>
        </li>
      )}
      <li onClick={handleLogout}>
        <LogIn />
        <span>{translate('general.defaultHeader.logout')}</span>
      </li>
    </div>
  );

  const handleReadNotification = useCallback(
    (id: number, url: string) => {
      return async (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        ev.preventDefault();
        await userNotificationRepository.read(id);
        await fetchUnreadNotification();
        window.location.href = url;
      };
    },
    [fetchUnreadNotification],
  );

  const handleReadAllNotification = React.useCallback(() => {
    userNotificationRepository.readAll().then(() => {
      setFetchNotification(true);
    });
  }, []);

  // phần mới thêm vào
  const [visibleLanguage, setVisibleLanguage] = React.useState<boolean>(false);
  const [selectedLanguage, setSelectedLanguage] = React.useState(
    localStorage.getItem('I18N_LANGUAGE'),
  );

  const handleSetLanguage = key => {
    // Store the selected language in localStorage
    localStorage.setItem('I18N_LANGUAGE', key);

    // Fetch the translation file for the selected language
    axios
      .get(path.join('/i18n', `${key}.json`))
      .then(async (response: AxiosResponse<any>) => {
        // Check if i18next is initialized
        if (!i18next) {
          // console.error('i18next is not initialized');
          return;
        }

        // Ensure i18next is fully initialized
        if (!i18next.isInitialized) {
          try {
            await i18next.init();
          } catch (error) {
            // console.error('Error initializing i18next:', error);
            return;
          }
        }

        // Check if translation data is valid
        if (!response.data || typeof response.data !== 'object') {
          // console.error('Invalid translation data:', response.data);
          return;
        }

        // Add resources and change language (no need to await if they're not async)
        i18next.addResources(key, '', response.data);
        i18next.changeLanguage(key);
      });

    // Update the user profile
    const newProfile = { ...user };
    newProfile.languageId = key === 'vi' ? 1 : 2;

    AuthenticationService.updateProfile(newProfile).then(() => {
      setSelectedLanguage(key);
      setVisibleLanguage(false);
    });
  };
  const [currrentIndex, setCurrentIndex] = React.useState<number>(null);
  const [gatewayDropDown, setGatewayDropDown] = React.useState(false);
  const handleToggerGateway = React.useCallback(() => {
    setGatewayDropDown(!gatewayDropDown);
  }, [gatewayDropDown]);

  const internalValue = React.useMemo(() => {
    return (index: number, colorCode) => {
      return index === currrentIndex ? { color: `${colorCode}` } : {};
    };
  }, [currrentIndex]);

  const handleMouseEnter = React.useCallback(index => {
    setCurrentIndex(index);
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    setCurrentIndex(null);
    setVisibleApp(false);
  }, [setVisibleApp]);

  const handleMouseLeaveAll = React.useCallback(() => {
    setGatewayDropDown(false);
    setVisibleApp(false);
  }, [setVisibleApp]);

  return {
    handleClickToProfile,
    handleClickToChangePassword,
    handleLogout,
    setVisibleNotification,
    visibleNotification,
    loading,
    handleShowApp,
    handleClickToNotification,
    handleToggleNotification,
    visibleApp,
    setVisibleApp,
    menu,
    handleClick,
    codeLanding,
    subcribeChannel,
    loadingNotification,
    notifications,
    handleInfiniteOnLoad,
    hasMore,
    total,
    handleReadNotification,
    handleReadAllNotification,
    unreadNotification,
    visibleMenuAction,
    handleToggleMenuAction,
    menuLandingPage,
    gatewayDropDown,
    visibleLanguage,
    setVisibleLanguage,
    selectedLanguage,
    setSelectedLanguage,
    handleSetLanguage,
    handleToggerGateway,
    internalValue,
    handleMouseEnter,
    handleMouseLeave,
    handleMouseLeaveAll,
    PortalPermission,
  };
}

const notificationConfig = (data: UserNotification) => ({
  message: (
    <div
      className="content-noti-ellipsis"
      dangerouslySetInnerHTML={{
        __html:
          localStorage.getItem('I18N_LANGUAGE') === 'vi'
            ? data.contentWeb
            : data.engContentWeb,
      }}
    ></div>
  ),
  description: (
    <div
      className="content-noti-ellipsis"
      dangerouslySetInnerHTML={{
        __html:
          localStorage.getItem('I18N_LANGUAGE') === 'vi'
            ? data.contentWeb
            : data.engContentWeb,
      }}
    ></div>
  ),
  icon: (
    <>
      {data?.siteId === 2 && (
        <div
          style={{
            background: '#a32f4a',
            width: 35,
            height: 35,
            lineHeight: '35px',
            borderRadius: '50%',
            margin: 'auto',
            textAlign: 'center',
            color: '#ffffff',
          }}
          className="icon-toast-dms ml-1 mr-3"
        >
          <i className="tio-shop_outlined" />
        </div>
      )}

      {data?.siteId === 1 && (
        <div
          style={{
            background: '#7d71f1',
            width: 35,
            height: 35,
            lineHeight: '35px',
            borderRadius: '50%',
            margin: 'auto',
            textAlign: 'center',
            color: '#ffffff',
          }}
          className="icon-toast-portal ml-1 mr-3"
        >
          <i className="tio-shop_outlined" />
        </div>
      )}

      {data?.siteId === 3 && (
        <div
          style={{
            background: '#0096c7',
            width: 35,
            height: 35,
            lineHeight: '35px',
            borderRadius: '50%',
            margin: 'auto',
            textAlign: 'center',
            color: '#ffffff',
          }}
          className="icon-toast-crm ml-1 mr-3"
        >
          <i className="tio-shop_outlined" />
        </div>
      )}

      {data?.siteId === 4 && (
        <div
          style={{
            background: '#23282c',
            width: 35,
            height: 35,
            lineHeight: '35px',
            borderRadius: '50%',
            margin: 'auto',
            textAlign: 'center',
            color: '#ffffff',
          }}
          className="icon-toast-report ml-1 mr-3"
        >
          <i className="tio-shop_outlined" />
        </div>
      )}
    </>
  ),
  onClick: async () => {
    await userNotificationRepository.read(data.id);
    setTimeout(() => {
      window.location.href = data.linkWebsite
        ? buildAbsoluteLink(data.linkWebsite)
        : '#';
    }, 0);
  },
});

export const COUNT_UNREAD = 'COUNT_UNREAD';

function newNotificationReducer(state: number, action) {
  switch (action.type) {
    case 'COUNT_UNREAD': {
      return action.payload.total;
    }
    default:
      return state;
  }
}
